import React, {useState} from 'react';
import {SdfInput, SdfAlert} from '@synerg/react-components';
import {Controller} from 'react-hook-form';
import trim from 'lodash/trim';
import get from 'lodash/get';
import {validateEmail} from '../../../common';
import {SdfPhoneNumberInput} from '@synerg/react-components';
import {parsePhoneNumber} from 'libphonenumber-js';
import {SdfIcon} from '@synerg/react-components';
import {SdfTooltip} from '@synerg/react-components';

export default function StepThree({control}) {
	const infoHoverText = 'This person will be added as a security master admin within ADP\'s identity system (NetSecure). ' +
			'This person will also be able to access the Marketplace as an admin with permission to view billing details and assign additional user roles and access.';
	const [onFirstRender, setOnFirstRender] = useState(0);

	const validateThePhone = {
		invalidPhone: value => validatePhone(value) || 'Invalid Phone Number',
	};

	const validateName = (val) => {
		const name = val || '';
		return typeof name === 'string' && name.trim().length > 0 && !removeAccents(val).match(/[^a-z'\s]/gi);
	};

	const removeAccents = text => {
		return typeof text === 'string'
			? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
			: '';
	};

	const validatePhone = (val) => {
		try {
			const {
				countryCode, valueNational, valueInternational, countryPrefix,
			} = val;
			return (countryCode && valueNational && valueInternational &&
					countryPrefix) ? true : false;

		} catch (e) {
			return false;
		}
	};

	const valueNationalPhone = (internationalPhone, defaultVal) => {
		try {
			const phoneNumber = parsePhoneNumber(internationalPhone);
			return phoneNumber.formatNational();
		} catch (e) {
			return defaultVal;
		}

	};

	const ShowError = ({message}) => {
		return (<SdfAlert
				className="mt-1"
				slot="alert"
				size="sm"
				status="error"
				type="inline"
		>
			{message}
		</SdfAlert>);
	};
	return (<div className="mt-12">
		<div className="text-heading-05 font-bold mb-3">Assign an admin <SdfTooltip
				className="ml-1"
				attachmentPoint={'right'}
				positionContext={'ELEMENT'}
		>
			<SdfIcon icon="alert-info" size="sm" slot="tooltip-target"/>
			<span>{infoHoverText}</span>
		</SdfTooltip></div>
		<div className="mb-6">All fields required.</div>

		<section className="form2" style={{marginBottom: '7rem'}}>
			<div className="w-full">
				<Controller
						name="firstName"
						control={control}
						rules={{
							validate: val => validateName(val) || 'Invalid first name',
							required: 'This field is required',
						}}
						render={({
							field: {value, onChange, onBlur}, fieldState: {error},
						}) => (<SdfInput
								label="First name"
								name="firstName"
								className={error ? 'w-1/2' : 'w-1/2 mb-6'}
								value={value}
								state={error ? 'error' : 'normal'}
								onSdfInput={(e) => onChange(e.target.value)}
								onBlur={(e) => onBlur(e.target.value)}
								required="true"
								requiredState="required"
						>
							{error && error.message && <ShowError message={error.message}/>}
						</SdfInput>)}
				/>
			</div>
			<div className="w-full">
				<Controller
						name="lastName"
						control={control}
						rules={{
							validate: val => validateName(val) || 'Invalid last name',
							required: 'This field is required',
						}}
						render={({
							field: {value, onChange, onBlur}, fieldState: {error},
						}) => (<SdfInput
								label="Last name"
								name="lastName"
								className={error ? 'w-1/2' : 'w-1/2 mb-6'}
								value={value}
								state={error ? 'error' : 'normal'}
								onSdfInput={(e) => onChange(e.target.value)}
								onBlur={(e) => onBlur(e.target.value)}
								required="true"
								requiredState="required"
						>
							{error && error.message && <ShowError message={error.message}/>}
						</SdfInput>)}
				/>
			</div>
			<div className="w-full">
				<Controller
						name="emailAddress"
						control={control}
						rules={{
							validate: val => validateEmail(trim(val)) ||
									'Incorrect email format', required: 'This field is required',
						}}
						render={({
							field: {value, onChange, onBlur}, fieldState: {error},
						}) => (<SdfInput
								label="Email address"
								name="emailAddress"
								className={error ? 'w-1/2' : 'w-1/2 mb-6'}
								value={value}
								state={error ? 'error' : 'normal'}
								onSdfInput={(e) => onChange(e.target.value)}
								onBlur={(e) => onBlur(e.target.value)}
								required="true"
								requiredState="required"
						>
							{error && error.message && <ShowError message={error.message}/>}
						</SdfInput>)}
				/>
			</div>
			<div className="w-full">
				<Controller
						name="preferredPhoneNumber"
						control={control}
						rules={{
							validate: validateThePhone, required: 'This field is required',
						}}
						render={({
							field: {value, onChange, onBlur}, fieldState: {error},
						}) => (<SdfPhoneNumberInput
								{...(get(value, 'countryPrefix', '') ? {
									countryCode: get(value, 'countryPrefix', 'US'),
								} : {})}
								{...(get(value, 'valueNational', '') && onFirstRender === 0
										? {value: get(value, 'valueNational', '')}
										: {})}
								label="Preferred phone number"
								name="preferredPhoneNumber"
								className={error ? 'w-1/2' : 'w-1/2 mb-6'}
								state={error ? 'error' : 'normal'}
								onSdfChange={(e) => {
									onChange(e.detail);
									setOnFirstRender(prev => prev + 1);
								}}
								onSdfInvalidNumber={(e) => {
									onChange({
										countryPrefix: e.target.countryCode,
										valueNational: valueNationalPhone(
												e.detail.valueInternational, e.target.value),
										valueInternational: e.detail.valueInternational,
									});
									setOnFirstRender(prev => prev + 1);
								}}
								requiredState="required"
								filterable={true}
						>
							{error && error.message && <ShowError message={error.message}/>}
						</SdfPhoneNumberInput>)}
				/>
			</div>

		</section>

	</div>);

}
